const locale = {
  COMPANY_STATISTICS: 'Аналітика',
  COMPANY_STATISTICS_DESCRIPTION: 'Відстежуйте показники, перевіряйте звіти та ефективність',

  DOCUMENT_CAPTURE: 'Обробка документу',
  CLEAN_DOCUMENT_CAPTURE: 'Очистити обробку документу',
  BARCODE_CAPTURE: 'Обробка штріхкоду',
  CREDIT_CARD_CAPTURE: 'Обробка кредитної картки',
  RFID_DOCUMENT_CAPTURE: 'Обробка Rfid документу',
  SPECIFIC_DOCUMENT_CAPTURE: 'Обробка спеціалізованого документу',
  SELFIE_CAPTURE: 'Обробка селфі',
  FACE_CAPTURE: 'Обробка обличчя',
  PASSIVE_FACE_MATCH: 'Розпізнавання обличчя',
  FACE_LIVENESS: 'Перевірка автентичності',
  SIGNATURE: 'Підпис',
  OTP_VERIFICATION: 'Верифікація одноразового пароля',
  UTILITY_BILL: 'Рахунок за комунальні послуги',
  DIIA: 'Дія',
  PASSIVE_LIVENESS: 'Перевірка автентичності',

  // STATISTICS DASHBOARD
  STATS_PRESET_TODAY: 'Сьогодні',
  STATS_PRESET_7_DAYS: '7 днів',
  STATS_PRESET_30_DAYS: '30 днів',
  ALL_WORKFLOWS: 'Усі робочі процеси',
  STATS_WORKFLOWS_LOADING: 'Завантаження робочих процесів…',
  STATS_RANGE_ORDER: 'Дата завершення раніша за дату початку. Оберіть інший період.',
  STATS_RANGE_TOO_LONG: 'Період задовгий. Оберіть не більше {{max}} днів.',
  STATS_ERROR_BUSY: 'Сервіс зараз зайнятий. Це не впливає на інші блоки.',
  STATS_ERROR_INVALID: 'Цей період не можна показати: {{field}}',
  STATS_ERROR_INVALID_PERIOD: 'Цей період не можна показати',
  STATS_ERROR_GENERIC: 'Не вдалося завантажити цей блок',
  STATS_RETRY: 'Повторити',
  STATS_EMPTY: 'Немає даних за цей період',
  STATS_ERROR_FORBIDDEN: 'У вас немає доступу до цього блоку',
  STATS_EMPTY_FUNNEL: 'Немає сесій за цей період',
  STATS_EMPTY_SERVICES: 'За цей період нічого не списано',
  STATS_EMPTY_DECISIONS: 'Немає рішень за цей період',
  STATS_EMPTY_REBUILDING: 'Історія ще відновлюється',
  STATS_EMPTY_REBUILDING_HINT: 'Перевірте пізніше, коли історія відновиться',
  STATS_EMPTY_HINT_PERIOD: 'Спробуйте довший період або змініть фільтри',
  STATS_FIELD_period: 'період',
  STATS_FIELD_tz: 'часовий пояс',
  STATS_FIELD_appKey: 'робочий процес',
  STATS_NOTE_REBUILDING: 'Історія ще відновлюється, тому деякі числа можуть бути неповними.',
  STATS_NOTE_APPROXIMATE: 'Числа до {{since}} приблизні.',
  STATS_KPI_SESSIONS_STARTED: 'Розпочаті сесії',
  STATS_KPI_SESSIONS_COMPLETED: 'Завершені сесії',
  STATS_KPI_COMPLETION_RATE: 'Частка завершених',
  STATS_KPI_APPLICANTS_CREATED: 'Нові заявники',
  STATS_KPI_APPROVED: 'Схвалено',
  STATS_KPI_REJECTED: 'Відхилено',
  STATS_NOW_AWAITING_REVIEW: 'Очікують перевірки',
  STATS_NOW_ON_HOLD: 'Призупинено',
  STATS_NOW_REVIEWED_TODAY: 'Перевірено сьогодні',
  STATS_NOW_MEDIAN: 'медіана {{median}}',
  STATS_NOW_TODAY_ZONE: 'Сьогодні за часовим поясом {{zone}}',
  STATS_TREND_PP: 'в. п.',
  STATS_TREND_UP: 'Зростання',
  STATS_TREND_DOWN: 'Спад',
  STATS_TREND_FLAT: 'Без змін',
  STATS_TREND_VS_PREV: 'порівняно з попер.',
  STATS_TILE_TOOLTIP:
    'Цей період ({{from}} – {{to}}): {{current}} · Попередній ({{previousFrom}} – {{previousTo}}): {{previous}}',
  STATS_COUNT: 'Кількість',
  STATS_SHARE: 'Частка',
  STATS_TOTAL: 'Разом',
  STATS_OTHER: 'Інше',
  STATS_NO_CHART_DATA: 'Немає даних для графіка за цей період',
  STATS_FUNNEL_NO_PLATFORMS: 'Немає сесій у розрізі платформ за цей період',
  STATS_FUNNEL_NO_FAILURES: 'Немає невдалих сесій за цей період',
  STATS_GEO_NO_COUNTRIES: 'Немає сесій із відомою країною',
  STATS_REVIEWERS_NO_ACTIVITY: 'Немає активності операторів за цей період',
  STATS_FUNNEL_TITLE: 'Воронка верифікацій',
  STATS_FUNNEL_STARTED: 'Розпочато',
  STATS_FUNNEL_COMPLETED: 'Завершено',
  STATS_FUNNEL_FAILED: 'Невдало',
  STATS_FUNNEL_ABANDONED: 'Покинуто',
  STATS_FUNNEL_BY_PLATFORM: 'За платформами',
  STATS_FUNNEL_PLATFORM: 'Платформа',
  STATS_FUNNEL_FAILURE_REASONS: 'Основні причини невдач',
  STATS_FUNNEL_REASON: 'Причина',
  STATS_PLATFORM_WEB: 'Веб',
  STATS_PLATFORM_IOS: 'iOS',
  STATS_PLATFORM_ANDROID: 'Android',
  STATS_DECISIONS_TITLE: 'Рішення',
  STATS_DECIDED_BY_ALL: 'Усі',
  STATS_DECIDED_BY_REVIEWER: 'Оператор',
  STATS_DECIDED_BY_SYSTEM: 'Система',
  STATS_DECIDED_BY_UNATTRIBUTED: 'Не визначено',
  STATS_DECIDED_BY_TITLE: 'Хто вирішив',
  STATS_DECIDED_BY_NONE: 'Немає даних про те, хто ухвалив рішення',
  STATS_DECISIONS_NO_WARNINGS: 'Немає попереджень за цей період',
  STATS_OUTCOME: 'Результат',
  STATS_OUTCOME_APPROVED: 'Схвалено',
  STATS_OUTCOME_REJECTED: 'Відхилено',
  STATS_OUTCOME_INCOMPLETE: 'Повторне подання',
  STATS_OUTCOME_ON_HOLD: 'Призупинено',
  STATS_WARNINGS_TITLE: 'Попередження за типами',
  STATS_WARNING_TYPE: 'Попередження',
  STATS_WARNINGS_RAISED: 'Виникло',
  STATS_WARNINGS_RESOLVED: 'Вирішено',
  STATS_SERVICES_TITLE: 'Сервіси',
  STATS_SERVICE: 'Сервіс',
  STATS_SERVICES_ACCEPTED: 'Прийнято',
  STATS_SERVICES_REJECTED: 'Відхилено',
  STATS_SERVICES_FAILED: 'Невдало',
  STATS_SERVICES_SPEND: 'Витрати',
  STATS_SERVICES_SPEND_BY_SERVICE: 'Витрати за сервісами',
  STATS_SERVICES_BY_SERVICE: 'Використання за сервісами',
  STATS_SERVICES_NO_SPEND: 'Немає витрат за цей період',
  STATS_REVIEWERS_CHART_TITLE: 'Рішення за операторами',
  STATS_REVIEWERS_NO_DECISIONS: 'Немає рішень операторів за цей період',
  STATS_GEO_TITLE: 'Географія',
  STATS_GEO_DOCUMENT: 'Документ',
  STATS_GEO_PHONE: 'Телефон',
  STATS_GEO_IP: 'IP',
  STATS_GEO_COUNTRY: 'Країна',
  STATS_GEO_UNKNOWN: 'Без країни: {{value}}',
  STATS_GEO_DOCUMENT_HINT: 'Враховано кожен перевірений документ, зокрема відхилені',
  STATS_REVIEWERS_TITLE: 'Оператори',
  STATS_REVIEWER: 'Оператор',
  STATS_REVIEWER_ASSIGNED: 'Призначено',
  STATS_REVIEWER_DECISIONS: 'Рішення',
  STATS_SHOW_ALL: 'Показати всі ({{total}})',
  STATS_SHOW_LESS: 'Показати менше',
  STATS_BADGE_FAST: 'швидко',
  STATS_BADGE_SLOW: 'повільно',
  STATS_BADGE_SHARE: 'Частка схвалень {{share}}',
  STATS_MEDIAN: 'Медіана',
  STATS_P90: '90-й перцентиль',
  STATS_TIME_TO_DECISION: 'Час до рішення',
  STATS_TIME_TO_DECISION_SUMMARY_one:
    'Медіана {{median}}, 90-й перцентиль {{p90}} · виміряно {{total}} рішення',
  STATS_TIME_TO_DECISION_SUMMARY_few:
    'Медіана {{median}}, 90-й перцентиль {{p90}} · виміряно {{total}} рішення',
  STATS_TIME_TO_DECISION_SUMMARY_many:
    'Медіана {{median}}, 90-й перцентиль {{p90}} · виміряно {{total}} рішень',
  STATS_TIME_TO_DECISION_SUMMARY_other:
    'Медіана {{median}}, 90-й перцентиль {{p90}} · виміряно {{total}} рішення',
};

export default locale;
